/*
 * @Author: lxx
 * @Date: 2019-12-05 17:18:52
 * @Last Modified by: xiangr
 * @Last Modified time: 2021-11-25 15:03:07
 * 公共函数及组件封装
 */
import G from './../../config/g'

const sys_suffix = 'info_input'

/**
 * 加前缀session封装并同步全局G
 * @param {String} name session
 * @param {*} value
 */
export const saveSion = function(name, value) {
  if (typeof name == 'string' && name) {
    sessionStorage.setItem(sys_suffix + '_' + name, JSON.stringify(value))
    G[sys_suffix + '_' + name] = value
  } else {
    console.log('session命名格式有误')
  }
}

/**
 * 获取session数据
 * @param {String} name session
 */
export const readSion = function(name) {
  if (typeof name == 'string' && name) {
    let readName = sessionStorage.getItem(sys_suffix + '_' + name)
    return readName && readName !== 'undefined' ? JSON.parse(readName) : false
  } else {
    console.log('查询字段有误')
  }
}

/**
 * 移除session数据
 * @param {String} name session
 */
export const removeSion = function(name) {
  if (typeof name == 'string' && name) {
    sessionStorage.removeItem(sys_suffix + '_' + name)
  } else {
    console.log('查询字段有误')
  }
}

/**
 * 获取门户session数据
 * @param {String} name session
 */
export const readPortalSion = function(name) {
  if (typeof name == 'string' && name) {
    let readName = sessionStorage.getItem(sys_suffix + '_' + name)
    return readName && readName !== 'undefined' ? JSON.parse(readName) : false
  } else {
    console.log('查询字段有误')
  }
}

/**
 * 获取全局数据
 * @param {String} name session
 */
export const readGlob = function(name) {
  if (typeof name == 'string' && name) {
    return G[sys_suffix + '_' + name]
  } else {
    console.log('查询字段有误')
  }
}

/**
 * @description: 加前缀localStorage封装
 * @param {String} name 键名
 * @param {any} value 键值
 * @return {*}
 */
export const saveLocal = function(name, value) {
  if (typeof name == 'string' && name) {
    localStorage.setItem(sys_suffix + '_' + name, JSON.stringify(value))
  } else {
    console.log('命名格式有误')
  }
}

/**
 * @description: 获取localStorage数据
 * @param {String} name 键名
 * @return {*}
 */
export const readLocal = function(name) {
  if (typeof name == 'string' && name) {
    let readName = localStorage.getItem(sys_suffix + '_' + name)
    return readName !== 'undefined' ? JSON.parse(readName) : null
  } else {
    console.log('查询字段有误')
  }
}

export default {
  saveSion,
  readSion,
  removeSion,
  readGlob,
  readPortalSion,
  saveLocal,
  readLocal
}



// WEBPACK FOOTER //
// ./src/view/public/common.js